module.exports = __webpack_public_path__ + "static/media/animated_sourabh.c4a87352.png";